<script setup>
import { ref, watch } from "vue"

const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
})

const emit = defineEmits(["save-data"])
const us = ref({ ...props.data })

watch(
    () => props.data,
    (newVal) => {
        us.value = { ...newVal }
    },
    { immediate: true }
)

let isMounted = false

watch(
    us,
    (val) => {
    if (!isMounted) {
        isMounted = true
        return
    }
    emit("save-data", val)
    },
    { deep: true }
)

</script>
<template>
    <div class="container">
        <div class="row g-0">
            <div class="col-12">
                <div class="dashboard-sec payout-section freelancer-statements form-section">
                    <div class="field-item personal-info space-info">
                        <form novalidate>
                            <div class="row">
                                <div class="col-12 section-title">Sobre ti</div>
                                <div class="col-md-12">
                                    <div class="input-block min-characters">
                                    <label class="form-label-custom">¿Como te describirías?</label>
                                    <textarea class="form-control" rows="5" v-model="us.pers_description"></textarea>
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6">
                                    <div class="input-block">
                                        <label class="form-label-custom">Expectativa salarial</label>
                                        <input type="text" class="form-control" v-model="us.salary_expect"/>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* El <div class="container"> raíz de Bootstrap tiene ancho fijo por breakpoint
   y se auto-centra, lo que descuadraba el margen izquierdo/derecho dentro de
   la columna. Aquí debe ocupar el 100% real de su columna, sin ese límite. */
.container {
    max-width: none;
    width: 100%;
    margin: 0;
    padding: 0;
}

/* .personal-info es una clase global del tema que limita el ancho a 1050px y
   agrega mucho padding; en esta página la tarjeta debe usar todo el ancho
   de su columna, así que se anulan esos límites solo aquí. */
:deep(.personal-info) {
    max-width: none;
    margin: 0;
    padding: 12px 8px;
}

.form-section {
    background: #fbfcfe;
    border: 1px solid #e3e8f0;
    border-radius: 12px;
    padding: 20px 16px 14px;
}
.section-title {
    font-weight: 700;
    color: #482775;
    margin: 18px 0 4px;
    padding-top: 12px;
    border-top: 1px dashed #e3e8f0;
}
.row > .section-title:first-child {
    margin-top: 0;
    padding-top: 0;
    border-top: none;
}
</style>
